module.exports = __webpack_public_path__ + "static/fonts/AmwayIcons.75de32d.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/views/surveys/sydney/font/AmwayIcons.ttf?5v2gxx
// module id = APF7
// module chunks = 0